import Counter from '../../../internal/platformMetrics/aggregators/Counter';
export const safeParams = [
    'dashboard_page_templates_list',
    'dashboard_page_templates_detail'
];
export default new Counter('frontend.platform-ui.dashboard-page-templates');

//# sourceMappingURL=dashboardPageTemplates.js.map